module.exports = __webpack_public_path__ + "img/IconoTelas.2528913f.png";